import { InternalScheduleActionDialogProps } from '../types';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { InternalScheduleActionDialogActions } from '../actions';

export const SpecialtyOverrideDialog = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
  disabled,
}: InternalScheduleActionDialogProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'specialtyOverride' });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <InternalScheduleActionDialogActions
          type="specialty"
          onCancel={() => {
            setOpen(false);
            onCancel();
          }}
          onConfirm={() => {
            setOpen(false);
            onConfirm();
          }}
          disabled={disabled}
        />
      </AlertDialogContent>
    </AlertDialog>
  );
};
